import {
  $post, $get, $JsonPost, ebopo,
} from '@/utils/axios-request';


const base = '';
class course {
  // 通过课密查询课程
  public async queryCoursesByCoursePass(postData: any): Promise<any> {
    return await $JsonPost(`${ebopo}/iuser/api/v1/queryCoursesByCoursePass`, postData);
  }

  // 提交课密与课程
  public async addNewCourse(postData: any): Promise<any> {
    return await $post(`${ebopo}/iuser/api/v1/addNewCourse`, postData);
  }
}
export default new course();
